import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()

export const contactUsApiBaseUrl = import.meta.env.VITE_CONTACT_US_API_URL
